import React from "react";
import PropTypes from "prop-types";
import InvitationsList from "components/GameInvitations/List/Index";
import InvitationsModal from "components/GameInvitations/Modal";
import { gameTypes, userTypes } from "domain/GamesSearch/types";

const GameDetailsInvitations = ({
    invitations,
    gameId,
    invitedGroups,
    game,
    isInvate = true,
}) => {
    return (
        <div className="card-full__bottom">
            <h4 className="fs-h3 hide-tablet-down mb-32">
                Приглашенные списки / игроки
            </h4>

            <div className="background-block">
                {invitations?.length === 0 && invitedGroups.length === 0 ? (
                    <p className="c-gs-label mb-16-24">
                        Игроки получат уведомление об игре. Также, если тип
                        набора закрытый, то игра станет доступна для
                        приглашенных пользователей.
                    </p>
                ) : (
                    <InvitationsList
                        invitations={invitations}
                        invitedGroups={invitedGroups}
                        players={game.players}
                    />
                )}
                <InvitationsModal
                    gameId={gameId}
                    invitedUsers={invitations}
                    isInvate={isInvate}
                />
            </div>
        </div>
    );
};

GameDetailsInvitations.default = {
    invitations: [],
    invitedGroups: [],
};

GameDetailsInvitations.propTypes = {
    invitations: PropTypes.arrayOf(userTypes),
    gameId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    invitedGroups: PropTypes.array,
    isInvate: PropTypes.bool,
    game: PropTypes.arrayOf(gameTypes),
};

export default GameDetailsInvitations;
